import { render, staticRenderFns } from "./DigitalManagement.vue?vue&type=template&id=2c490d04&lang=pug"
import script from "./DigitalManagement.vue?vue&type=script&lang=js"
export * from "./DigitalManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports